import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Container, Row, Col, Button } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import config from '../../../../config';

import { getMainProduct, getProductSlugPath } from '../../../Product/ProductActions';
import { getContentBlockItemByName, getContentBlockMixedItems, getContentBlockMixedItem } from '../../../Cms/CmsActions';
import { getLanguagePath, getTranslation } from '../../../Intl/IntlActions';

import AppLogo from '../../components/AppLogo';
import PreFooter from '../../components/PreFooter';
import AppAdvantages from '../../components/AppAdvantages';

import CmsBlockItem from '../../../Cms/components/content/CmsBlockItem';
import ReviewSummary from '../../../Review/components/view/ReviewSummary';

import Dashboard from '../../../User/components/Dashboard';
import Loader from '../../../../components/Loader/Loader';

function HomePage({ page, intl }) {
    if(page) {
        const topSlide = getContentBlockItemByName(page.blocks, 'top-slide');
        const priceSlide = getContentBlockItemByName(page.blocks, 'price-slide');
        const benefitSlide = getContentBlockItemByName(page.blocks, 'benefit-slide');
        const compositionSlide = getContentBlockItemByName(page.blocks, 'composition-slide');

        const topSlideLink = topSlide && getContentBlockMixedItem(topSlide, 'call-to-action').path;

        return (
            <Fragment>
                {topSlide && (
                    <Container fluid className="bg-secondary" style={{ marginBottom: '-70px' }}>
                        <Container className="pb-5 bg-custom-plant">
                            <Row className="pt-5">
                                <Col xs="12" lg="7">
                                    <div className="pl-4 pl-md-0 px-2 px-md-0 pt-0 pt-md-5">
                                        {getContentBlockMixedItem(topSlide, 'title') && <CmsBlockItem item={getContentBlockMixedItem(topSlide, 'title')} type="html" />}
                                    </div>
                                    {/* Atremoplus &reg;, la garantie d'un complément alimentaire innonvant riche en <span className="text-primary">L-Dopa d'origine 100% naturelle</span> */}
                                    <div className="d-none d-lg-flex justify-content-between pt-3">
                                        <span>
                                            {getContentBlockMixedItem(topSlide, 'call-to-action') && (
                                                <Fragment>
                                                    {
                                                        topSlideLink.includes('http')
                                                        ? <Button color="light" size="lg" tag="a" href={topSlideLink} target="_blank" className="mt-2">{getContentBlockMixedItem(topSlide, 'call-to-action').text}</Button>
                                                        : <Button color="light" size="lg" tag={Link} to={topSlideLink} className="mt-2">{getContentBlockMixedItem(topSlide, 'call-to-action').text}</Button>
                                                    }
                                                </Fragment>
                                            )}
                                        </span>
                                        <CmsBlockItem item={getContentBlockMixedItem(topSlide, 'stamp-image')} type="image" />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="position-relative pl-4 d-none d-lg-block" style={{ minHeight: '460px' }}>
                                        <CmsBlockItem item={getContentBlockMixedItem(topSlide, 'product-image')} type="image" loadonmount className="position-absolute" style={{ maxHeight: '530px' }} />
                                    </div>
                                    <div className="position-relative d-block d-lg-none mt-5 pb-5 text-center">
                                        <CmsBlockItem item={getContentBlockMixedItem(topSlide, 'stamp-image')} type="image" className="position-absolute w-25" style={{ left: 0 }} />
                                        <CmsBlockItem item={getContentBlockMixedItem(topSlide, 'product-image')} type="image" style={{ width: '60%' }} />
                                        <br />
                                        {getContentBlockMixedItem(topSlide, 'call-to-action') && (
                                            <Fragment>
                                                {
                                                    topSlideLink.includes('http')
                                                    ? <Button color="light" size="lg" tag="a" href={topSlideLink} target="_blank" className="mt-2">{getContentBlockMixedItem(topSlide, 'call-to-action').text}</Button>
                                                    : <Button color="light" size="lg" tag={Link} to={topSlideLink} className="mt-2">{getContentBlockMixedItem(topSlide, 'call-to-action').text}</Button>
                                                }
                                            </Fragment>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </Container>
                )}

                <Container className="px-3 pt-3 bg-white">
                    <Row>
                        <Col xs="12" lg="7">
                            <AppAdvantages isFullSize />
                        </Col>
                    </Row>
                </Container>

                {priceSlide && (
                    <Container className="bg-white" style={{ paddingTop: '20px' }}>
                        <Row className="pt-0 pt-md-4">
                            <Col xs="12" sm="6">
                                {getContentBlockMixedItem(priceSlide, 'image') && <CmsBlockItem item={getContentBlockMixedItem(priceSlide, 'image')} type="image" />}
                            </Col>
                            <Col className="py-2 py-sm-5">
                                <div className="override-block">
                                    {getContentBlockMixedItem(priceSlide, 'subtitle') && (
                                        <div className="mb-3 text-primary text-uppercase font-weight-bold">
                                            <CmsBlockItem item={getContentBlockMixedItem(priceSlide, 'subtitle')} type="text" />
                                        </div>
                                    )}
                                    {getContentBlockMixedItem(priceSlide, 'title') && (
                                        <div className="h2 mb-3">
                                            <CmsBlockItem item={getContentBlockMixedItem(priceSlide, 'title')} type="text" />
                                        </div>
                                    )}
                                    {getContentBlockMixedItem(priceSlide, 'text') && (
                                        <div className="mb-3">
                                            <CmsBlockItem item={getContentBlockMixedItem(priceSlide, 'text')} type="html" />
                                        </div>
                                    )}
                                    <div className="text-center text-md-left">
                                        {getContentBlockMixedItem(priceSlide, 'call-to-action') && (
                                            <Button color="light" size="lg" tag={Link} to={getContentBlockMixedItem(priceSlide, 'call-to-action').path} className="mt-2">{getContentBlockMixedItem(priceSlide, 'call-to-action').text}</Button>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                )}

                {benefitSlide && (
                    <Container className="py-2 py-sm-5 bg-white">
                        <Row>
                            <Col xs={{ size: 12, order: 2 }} sm={{ size: 6, order: 1 }} className="py-0 py-md-5">
                                <div className="override-block">
                                    {getContentBlockMixedItem(benefitSlide, 'title') && (
                                        <div className="h2 mb-3">
                                            <CmsBlockItem item={getContentBlockMixedItem(benefitSlide, 'title')} type="text" />
                                        </div>
                                    )}
                                    {getContentBlockMixedItem(benefitSlide, 'subtitle') && (
                                        <div className="mb-3 special-font text-dark text-lg font-weight-bold">
                                            <CmsBlockItem item={getContentBlockMixedItem(benefitSlide, 'subtitle')} type="text" />
                                        </div>
                                    )}
                                    {getContentBlockMixedItems(benefitSlide, 'benefits') && (
                                        <ul className="mb-3 list-unstyled list-item-check">
                                            {getContentBlockMixedItems(benefitSlide, 'benefits').map((benefit, index) => <li key={index}>{benefit.text}</li>)}
                                        </ul>
                                    )}
                                    <div className="text-center text-md-left">
                                        {getContentBlockMixedItem(benefitSlide, 'call-to-action') && (
                                            <Button color="light" size="lg" tag={Link} to={getContentBlockMixedItem(benefitSlide, 'call-to-action').path} className="mt-2">{getContentBlockMixedItem(benefitSlide, 'call-to-action').text}</Button>
                                        )}
                                    </div>
                                </div>
                            </Col>
                            <Col xs={{ size: 12, order: 1 }} sm={{ size: 6, order: 2 }} className="">
                                <div className="position-relative">
                                    <Row>
                                        <Col xs="12" md="8">
                                            {getContentBlockMixedItem(benefitSlide, 'image') && <CmsBlockItem item={getContentBlockMixedItem(benefitSlide, 'image')} type="image" />}
                                        </Col>
                                        <Col className="d-none d-md-block">
                                            {topSlide && getContentBlockMixedItem(topSlide, 'stamp-image') && <CmsBlockItem item={getContentBlockMixedItem(topSlide, 'stamp-image')} type="image" className="p-lg-2 pt-lg-4 align-top" />}
                                        </Col>
                                    </Row>
                                    {getContentBlockMixedItem(benefitSlide, 'image-text') && (
                                        <div className="d-none d-md-block position-absolute mr-3 p-2 p-lg-4 w-50 bg-secondary text-lg text-white special-font" style={{ bottom: '-30px', right: '-30px' }}>
                                            <CmsBlockItem item={getContentBlockMixedItem(benefitSlide, 'image-text')} type="text" />
                                        </div>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                )}

                {compositionSlide && (
                    <Container fluid className="bg-tertiary bg-custom-chemical">
                        <Container className="px-3 px-md-0 py-2 py-sm-5">
                            <Row>
                                <Col xs="12" sm="6" className="text-center">
                                    {getContentBlockMixedItem(compositionSlide, 'image') && <CmsBlockItem item={getContentBlockMixedItem(compositionSlide, 'image')} type="image" className="image-shadow" />}
                                </Col>
                                <Col className="py-2 py-sm-5">
                                    <div className="pt-3 pt-md-0">
                                        {getContentBlockMixedItem(compositionSlide, 'subtitle') && (
                                            <div className="mb-3 text-primary text-uppercase">
                                                <CmsBlockItem item={getContentBlockMixedItem(compositionSlide, 'subtitle')} type="text" />
                                            </div>
                                        )}
                                        {getContentBlockMixedItem(compositionSlide, 'title') && (
                                            <div className="h2 mb-3 special-font text-dark">
                                                <CmsBlockItem item={getContentBlockMixedItem(compositionSlide, 'title')} type="text" />
                                            </div>
                                        )}

                                        {getContentBlockMixedItem(compositionSlide, 'text') && (
                                            <div className="mb-3">
                                                <CmsBlockItem item={getContentBlockMixedItem(compositionSlide, 'text')} type="html" />
                                            </div>
                                        )}
                                        <div className="text-center text-md-left">
                                            {getContentBlockMixedItem(compositionSlide, 'call-to-action') && (
                                                <Button color="light" size="lg" tag={Link} to={getContentBlockMixedItem(compositionSlide, 'call-to-action').path} className="mt-2">{getContentBlockMixedItem(compositionSlide, 'call-to-action').text}</Button>
                                            )}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </Container>
                )}

                <ReviewSummary locale={intl.locale} />

                <PreFooter />
            </Fragment>
        );
    }
    return null;
}


HomePage.propTypes = {
    intl: intlShape.isRequired,
    page: PropTypes.object.isRequired,
};

export default injectIntl(HomePage);

export const HomePageModel = {
    type: 'page',
    name: 'home',
    slug: '*',
    blocks: [
        {
            name: 'top-slide',
            type: 'mixed',
            max: 1,
            blocks: [
                {
                    name: 'title',
                    type: 'html',
                    max: 1,
                },
                {
                    name: 'call-to-action',
                    type: 'link',
                    max: 1,
                },
                {
                    name: 'product-image',
                    type: 'image',
                    max: 1,
                },
                {
                    name: 'stamp-image',
                    type: 'image',
                    max: 1,
                },
            ],
        },
        {
            name: 'price-slide',
            type: 'mixed',
            max: 1,
            blocks: [
                {
                    name: 'subtitle',
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'title',
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'text',
                    type: 'html',
                    max: 1,
                },
                {
                    name: 'call-to-action',
                    type: 'link',
                    max: 1,
                },
                {
                    name: 'image',
                    type: 'image',
                    max: 1,
                },
            ],
        },
        {
            name: 'benefit-slide',
            type: 'mixed',
            max: 1,
            blocks: [
                {
                    name: 'title',
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'subtitle',
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'benefits',
                    type: 'text',
                },
                {
                    name: 'call-to-action',
                    type: 'link',
                    max: 1,
                },
                {
                    name: 'image',
                    type: 'image',
                    max: 1,
                },
                {
                    name: 'image-text',
                    type: 'text',
                    max: 1,
                },
            ],
        },
        {
            name: 'composition-slide',
            type: 'mixed',
            max: 1,
            blocks: [
                {
                    name: 'subtitle',
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'title',
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'text',
                    type: 'html',
                    max: 1,
                },
                {
                    name: 'call-to-action',
                    type: 'link',
                    max: 1,
                },
                {
                    name: 'image',
                    type: 'image',
                    max: 1,
                },
            ],
        },
    ],
};
